<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      如欲定制计时器，请联系：1045321156@qq.com<br>
      向您问候，希望使用愉快！
    </p>
    <h3>常用赛制</h3>
    <ul>
      <li>15秒与结束提示音测试:101</li>
      <li>华南理工大学新生杯赛制2021新版:131</li>
      <li>华南理工大学新生杯赛制怀旧版:44</li>
      <li>辩在华园:104</li><br>
      <li>黄联赛制:46</li>
      <li>北美联赛赛制:52</li>
      <li>新国辩:61</li>
      <li>奥瑞冈:65</li>
      <li>ai赛:85</li>
      <li>华夏杯:82</li>
      <li>30秒与结束提示音测试:138</li>

    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
